import { Box } from '@material-ui/core';
import { OrdersList } from 'features/order-history/components/OrdersList';
import { useTranslation } from 'hooks/useTranslation';

import React from 'react';
import { Title } from 'shared';

export const OrderHistoryPage: React.FC = () => {
  const { t } = useTranslation('app');

  return (
    <>
      <Title title={t('orderHistory')} />
      <Box>
        <OrdersList />
      </Box>
    </>
  );
};
